// removed by extract-text-webpack-plugin
module.exports = {"ModalWrapper":"Modal-module__ModalWrapper__17S-K","ModalWrapperLandingPortrait":"Modal-module__ModalWrapperLandingPortrait__3U72u Modal-module__ModalWrapper__17S-K","ModalWrapperFixed":"Modal-module__ModalWrapperFixed__1aO0X Modal-module__ModalWrapper__17S-K","Modal":"Modal-module__Modal__Rgf_C","ModalCheckout":"Modal-module__ModalCheckout__3jwMQ","Navbar":"Modal-module__Navbar__3noC3","Children":"Modal-module__Children__2F1dN","ChildrenDifferent":"Modal-module__ChildrenDifferent__iCpyI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.module.css
// module id = 1688
// module chunks = 29